module.exports = __webpack_public_path__ + "img/159.0c3172f2.jpg";